module.exports = __webpack_public_path__ + "2251af918ebd972099980e53cfe89af5.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/whats-new.html
// module id = 1912
// module chunks = 0